import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Link } from "react-router-dom";

import { Tab, Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const LinkButton = styled(Link)(
    ({ theme }: ParamsStyle) => `
        width: 100%;
        display: flex;
        height: 2.5rem;
        border-radius: 5px;
        text-aling: center;
        align-items: center;
        justify-content: center;
        border: 2px solid ${theme?.palette.primary.main};

        font-size: 1rem;
        font-weight: 700;
        color: ${theme?.palette.primary.main};
`);

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
    .MuiTabs-indicator {
        height: 1.75rem;
        border-radius: 5px 5px 0px 0px;
        border-top: 2.6px solid #8D9BB5;
        border-right: 2.6px solid #8D9BB5;
        border-left: 2.6px solid #8D9BB5;
        border-bottom: 2.6px solid white;
        background-color: transparent;
    }

    .MuiTabs-flexContainer {
        height: 100%;
        align-items: flex-end;
        justify-content: space-between;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        .MuiTabs-flexContainer {
            justify-content: space-around;
        }

        .MuiTabs-indicator {
            height: 2.5625rem;
        }
    }
`);

export const TabCustom = styled(Tab)(
    ({ theme }: ParamsStyle) => `
        color: white;
        min-height: 0;
        font-weight: 600;
        font-size: .8rem;
        padding: .45rem .6rem .1rem;
        border-radius: 5px 5px 0px 0px;
        background: rgba(141, 155, 181, 0.5);
        transition: all 450ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

        &.Mui-selected {
            background: transparent;
            padding: .65rem .6rem .2rem;
            color: ${theme?.palette.primary.main};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            font-size: 1.25rem;
            padding: .35rem 1.2rem .1rem;

            &.Mui-selected {
                padding: .8rem 1.2rem .2rem;
            }
        }
`);